import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCfZjS_OYiZXhs5DthqcdJzYw6WkWkcUqE",
  authDomain: "cryptoindicators-67e8e.firebaseapp.com",
  projectId: "cryptoindicators-67e8e",
  storageBucket: "cryptoindicators-67e8e.firebasestorage.app",
  messagingSenderId: "91468523903",
  appId: "1:91468523903:web:7cc5e6608255b39cb7d24a",
  measurementId: "G-VMK0SFTPXE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Analytics (optional - only in browser environment)
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

// Test Firebase initialization
console.log('Firebase initialized:', {
  app: app.name,
  auth: auth.app.name,
  db: db.app.name,
  projectId: app.options.projectId
});

export default app; 